import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import DateFormat from '../../../commons/componentes/DateFormat';

const GrupoProveedorTabla = (props: any) => {

    const { grupoId, empresaId, proveedores, seleccionarEmpresa }: { grupoId: string; empresaId: string, proveedores: any[], seleccionarEmpresa?: any } = props;

    const dispatch = useDispatch();


    console.log('App loading');



    return (
        <div style={{ overflowX: 'auto', width: '100%' }}>
            <table className="table tabla-chica" style={{ minWidth: 300 }}>
                <thead>
                    <tr className='bg-primary'>
                        <th>Proveedor</th>
                        <th>Alias</th>
                        <th>Alta</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {proveedores.map((proveedor, index: number) => (
                        <tr key={proveedor.id ?? index}
                            className={proveedor.id === Number(empresaId) ? "selected" : ""}
                        >
                            <td>{proveedor.proveedor.nombre}</td>
                            <td>{proveedor.alias}</td>
                            <td><DateFormat value={proveedor.fechaAlta}></DateFormat></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default GrupoProveedorTabla;
